export const getNodeText = (node) => {
    for (const childNodes of node.childNodes) {
        if (childNodes.nodeType === Node.TEXT_NODE && childNodes.textContent.trim()) {
            return node.textContent.trim();
        }
    }
}

export const parseDate = (dateString) => {
    return dateString.split(',')[0]
}

export const scoreToOutOfFive = (percentage) => {
    percentage = percentage.replace('%', '')
    return (Number(percentage) * 5 / 100).toFixed(1)
}

export const hasSportRouteCommentsLoaded = () => {
    const comment = document.querySelector('.routeYou_comment');
    const commentArea = document.querySelector('.routeYou_commentArea')
    return !(!comment || !commentArea);
    
}
